<template>
  <div>
    <ca-heading text="Rescisão" />
    <ca-row>
      <ca-col>
        <ca-button theme="primary" @click="onGenerate">Gerar rescisão</ca-button>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col>
        <ca-async-content-wrapper
          :key="wrapperKey"
          :on-fetch="getTerminations"
          :on-fetch-success="setTerminations">
          <ca-table v-if="terminations">
            <ca-tr slot="header">
              <ca-th>Trabalhador</ca-th>
              <ca-th>Data</ca-th>
              <ca-th>Motivo</ca-th>
              <ca-th></ca-th>
            </ca-tr>

            <ca-tr
              v-for="(termination, index) in terminations"
              :key="index"
              @click="onView(termination.id)">
              <ca-td>
                {{ `${termination.trabalhador.matricula} - ${termination.trabalhador.nome}` }}
              </ca-td>
              <ca-td>{{ termination.dtRescisao }}</ca-td>
              <ca-td>{{ termination.causa.description }}</ca-td>
              <ca-td>
                <ca-button
                  class="ca-u-min-margin-right"
                  size="small"
                  @click.stop="onRedo(termination.id)">
                  Refazer
                </ca-button>
                <ca-button size="small" @click.stop="onDelete(termination.id, index)">
                  Excluir
                </ca-button>
              </ca-td>
            </ca-tr>
          </ca-table>
        </ca-async-content-wrapper>
      </ca-col>
    </ca-row>

    <ca-row v-if="shouldShowPagination">
      <ca-col>
        <ca-pagination
          v-model="page"
          class="ca-u-flex ca-u-justify-content--center"
          :total-pages="totalPages"
          @change-page="onPageChange">
        </ca-pagination>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import TerminationViewRollver from './modals/termination-view-rollover/TerminationViewRollover';
import {
  DELETE_TITLE, DELETE_MESSAGE, DELETE_CONFIRM_TEXT, DELETE_SUCCESS_MESSAGE, DELETE_ERROR_MESSAGE,
} from './constants';
import { getTerminations, deleteTermination } from './terminationService';

export default {
  name: 'TerminationPage',
  data() {
    return {
      wrapperKey: 0,
      terminations: null,
      page: 0,
      totalPages: 0,
    };
  },
  computed: {
    shouldShowPagination() {
      return this.totalPages > 1;
    },
  },
  methods: {
    getTerminations() {
      return getTerminations(this.page);
    },
    setTerminations(response) {
      const {
        content: terminations,
        number: page,
        totalPages,
      } = response;
      Object.assign(this, { terminations, page, totalPages });
    },
    updateList() {
      this.wrapperKey++;
    },
    onGenerate() {
      this.$router.push({ name: 'TerminationForm' });
    },
    onView(terminationId) {
      this.$dialogModal(TerminationViewRollver, {
        props: { terminationId },
        on: {
          'on-delete': () => this.$delete(this.terminations.content),
        },
      }).open();
    },
    onRedo(terminationId) {
      this.$router.push({ name: 'TerminationRedoForm', params: { id: terminationId } });
    },
    onDelete(terminationId) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: DELETE_CONFIRM_TEXT,
        onConfirm: () => {
          deleteTermination(terminationId)
            .then(() => {
              this.$toaster.success(DELETE_SUCCESS_MESSAGE);
              this.onPageChange(this.page);
            })
            .catch(() => {
              this.$toaster.error(DELETE_ERROR_MESSAGE);
            });
        },
      });
    },
    onPageChange(page) {
      this.page = page;
      this.updateList();
    },
  },
};
</script>
